"use client";

import { usePathname } from "next/navigation";
import { UnifiedGroupSidebar } from "@/components/GroupAdminSidebar";
import { activeGroupSlug } from "@/lib/groupSlug";

export default function GrupperLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  const groupSlug = activeGroupSlug(pathname);

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-950">
      <div className="max-w-[1400px] mx-auto flex gap-4 px-2 py-3 sm:px-4 sm:py-4">
        <div className="hidden lg:block w-72 shrink-0">
          <div className="sticky top-[4.5rem]">
            <UnifiedGroupSidebar slug={groupSlug} />
          </div>
        </div>

        <div className="flex-1 min-w-0">{children}</div>
      </div>
    </div>
  );
}
